import * as React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { useGlobalState } from '../hooks';
export const DefaultRouter = ({ children }) => {
    const publicPath = useGlobalState((s) => s.app.publicPath);
    return React.createElement(BrowserRouter, { basename: publicPath }, children);
};
//# sourceMappingURL=DefaultRouter.js.map